import React from 'react';
import { InfoSection, Pricing  } from '../../components';
import Products from '../../components/InfoSection/Products';
import { homeObjOne, homeObjTwo, homeObjThree } from './Data';
function productsandservices() {
  return (
    <>
    <Pricing />
<Products />

      {/* <InfoSection {...homeObjOne} />
      <InfoSection {...homeObjTwo} />
      <InfoSection {...homeObjThree} /> */}

    </>
  );
}

export default productsandservices;
